import { doAddEvent, doRemoveEvent } from 'lib/events';
import { randomKey } from 'lib/riskbase';
import React from 'react';
import { useDispatch } from 'react-redux';
import { ALERT } from 'store/app/actions';
import { createAction } from 'typesafe-actions';

type HandleAlert = ({
  text,
  title,
  onConfirm,
}: {
  text: string;
  title?: string;
  onConfirm?: () => void;
}) => void;

export const useAlert = (): HandleAlert => {
  const dispatch = useDispatch();
  const keyRef = React.useRef<string>(`-alert-${randomKey()}`);

  const confirmType = React.useMemo(
    () => createAction(`USE_ALERT_CONFIRM_ACTION${keyRef.current}`)(),
    [],
  );

  const onRef = React.useRef<{
    confirm: () => void;
  }>(null);

  React.useEffect(() => {
    const eventConfirm = doAddEvent(confirmType, () =>
      onRef.current?.confirm(),
    );
    return () => {
      doRemoveEvent(eventConfirm);
    };
  }, [confirmType]);

  return React.useCallback(
    ({ text, title, onConfirm }) => {
      onRef.current = {
        confirm: () => onConfirm?.(),
      };
      dispatch(ALERT({ text, title, onConfirm: confirmType() }));
    },
    [confirmType, dispatch],
  );
};
